<template>
  <div>
    <div v-if="metadata != null">
      <gerdau-crud-meta-view
        :service="service"
        :metadata="metadata"
        translatePrefix="application.pages"
      />
    </div>
    <div class="import-data">
      <ImportData
        :service="service"
        :templateUrl="templateName"
        :templateName="name"
        @update-table="refreshTable"
      />
    </div>
  </div>
</template>

<script>
import { GerdauCrudMetaView } from '../components/crud/index'
import { CrudAction } from '@brain/core'
import { vehicleService } from '../services'
import { ImportData } from '../components/importData/index'
import { helpers } from '../helpers'
import { handleError } from '../helpers'
import api from '../boot/api'

export default {
  name: 'Vehicle',
  components: {
    GerdauCrudMetaView,
    ImportData
  },
  data: () => ({
    service: {
      ...vehicleService
    },
    metadata: null,
    name: 'vehicle',
    templateName: ''
  }),
  methods: {
    async refreshTable() {
      let bcGrid = helpers.findComponent(this, 'BcGrid')
      const [plantData] = await Promise.all([this.service.getAll()])
      bcGrid.aggridApi.setRowData(plantData)
    },
    async getMeta() {
      const meta = await vehicleService.getMetaWithValidation()
      meta.permissions = [
        CrudAction.UPDATE,
        CrudAction.CREATE,
        CrudAction.IMPORT,
        CrudAction.EXPORT
      ]
      return meta
    }
  },
  created() {
    this.templateName = `./${this.name}.xlsx`
    this.service.getAll = async () => {
      try {
        return await vehicleService.getVehicleByUserCompany()
      } catch (e) {
        handleError(e)
      }
    }
    this.service.export = async () => {
      try {
        return await vehicleService.getExportVehicleByUserCompany()
      } catch (e) {
        handleError(e)
      }
    }
    this.service.getOptions = async () => {
      try {
        const baseURL = '/logisticaApi/vehicleType/optionsWithoutMarket'
        const response = await api.get(baseURL)
        const data = Array.isArray(response.data.data)
          ? response.data.data
          : response.data

        return data
      } catch (e) {
        handleError(e)
      }
    }
    this.getMeta().then((meta) => {
      this.metadata = meta
    })
  }
}
</script>
<style lang="scss" scoped></style>
